import { render } from "./NSwitch.vue?vue&type=template&id=475983e0&ts=true"
import script from "./NSwitch.vue?vue&type=script&lang=ts"
export * from "./NSwitch.vue?vue&type=script&lang=ts"

import "./NSwitch.vue?vue&type=style&index=0&id=475983e0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__